<template>
  <div>
    <div v-if=" vserverModel" class="container-fluid " style="min-height: 400px; max-width: 860px">
      <b-card-group columns>
        <b-card v-for="(item,key) in vserverModel"
                :key="item.product_key"
                :class="item.product_name"
                style="max-width: 200px">
          <template v-slot:header >
            <h3> {{item.product_name}}</h3>
          </template>
          <b-card-text >
            <h4>{{item.product_key}}</h4>
            <h2 v-if="item.status === 'pending'"> <b-spinner ></b-spinner> </h2>
            <h2 v-else-if="item.status === 'success'"> <i class="fa fa-check"></i></h2>
            <h2 v-else-if="item.status === 'error'"> <i class="fa fa-warning"></i></h2>

          </b-card-text>
          <footer class="text-left ml-5">
            <li>
                {{item.cores}} <b>Cores</b>
            </li>
            <li >
                {{item.memory}} <b>MB</b>
            </li>
            <li >
                {{item.disk}} <b>GB</b>
            </li>
          </footer>
        </b-card>
      </b-card-group>
    </div>
  </div>
</template>

<script>
  import {VserverOrder} from "@/store/models/vserver/vserver_order"
  import {Vserver} from "@/store/models/vserver/vserver";
  import {VserverOrderList} from "@/store/models/vserver/vserver_order_list";

  export default {
        name: "luma-order-vserver",
        computed:{
            orderList(){
                if(VserverOrder.all()) return VserverOrder.all()
            },
            vserverModel(){
              if(!VserverOrderList.all().length) return
              return VserverOrderList.all().map(el=>el)
            }
        },
      methods:{
          deleteOrder(item){
              VserverOrder.delete(item)
          }
      }
    }
</script>

<style scoped>
.Advanced{
  background: grey;
  color: white;
}
.Starter{}

.Galaxy{
  color: white;
  background: #343a40;
}
</style>



// WEBPACK FOOTER //
// src/components/datacenter/vserver_datacenter/luma-order-vserver.vue